/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { useIsMobile } from '../../utilities/sharedHooks/useIsMobile';

const Modal = ({ contentStyle = null, contentClassName = '', dialogClassName = '', ...props }) => {
  const isMobile = useIsMobile();

  return (
    <>
      {/* mobile layout */}
      {isMobile && (
        <div
          className="modal d-flex flex-column justify-content-end hide-scroll"
          style={{ flex: 1, overflowY: 'auto' }}>
          <div
            className={`d-block d-md-none modal-content hide-scroll h-auto d-flex flex-column bg-lighter w-100 pt-3 px-0 ps-3 rounded-0 rounded-top ${contentClassName}`}
            style={{
              ...{ maxHeight: '95vh' },
              ...contentStyle,
              paddingBottom: '8rem',
            }}>
            {props.children}
          </div>
        </div>
      )}

      {/* browser layout */}
      {!isMobile && (
        <div className="d-none modal d-md-block align-items-center">
          <div className={`modal-dialog ${dialogClassName} modal-dialog-centered`}>
            <div
              className="modal-content d-flex flex-column bg-lighter overflow-hidden"
              style={contentStyle}>
              {props.children}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

Modal.propTypes = {
  contentStyle: PropTypes.object,
  isScrollOverFlow: PropTypes.bool,
  contentClassName: PropTypes.string,
  dialogClassName: PropTypes.string,
  specialMobileContentClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withButtons: PropTypes.bool,
};

export default Modal;
